import { ptPlusBuyBackListing } from "redux/actions/adminPTPlusBuyBackFee";
import { palletTypeOptions } from "web/pages/private/Admin/PTPlus/BuyBackFeeRequests/Constants";

const getPalletTypeName = (pickupPalletType) => {
  const option = palletTypeOptions.find(option => option.value === pickupPalletType);
  return option ? option.label : "NA";
}
const prepareCsvData = (buyBackFeeData) => {
  let tempCsvData = buyBackFeeData.flatMap(item => {
    let mainDataRow = [];
    item.vendors.forEach(vendor => {
      if (vendor.feeDetails.length > 0) {
        vendor.feeDetails.forEach(feeDetail => {
          mainDataRow.push({
            BuyBackFeeId: item.id || "NA",
            CustomerName: item.customerName || "NA",
            CustomerLocationName: item.customerLocationName || "NA",
            City: item.city || "NA",
            State: item.state || "NA",
            Vendor: `${vendor.vendorLocationName}${vendor.city ? `- ${vendor.city}` : ''}${vendor.state ? `- ${vendor.state}` : ''}` || "NA",
            PalletType: getPalletTypeName(feeDetail.pickupPalletType),
            VendorFee: `$${feeDetail?.vendorFee?.toFixed(2)}` || "NA",
            CustomerFee: `$${feeDetail?.customerFee?.toFixed(2)}` || "NA",
            StartDate: feeDetail.rateStartDate || "NA",
            EndDate: feeDetail.rateExpirationDate || "NA",
            Comment: feeDetail?.comment && feeDetail.comment?.replaceAll(",", " ")?.replaceAll("\n", " ")?.replaceAll("\r", " ") || 'NA'
          });
        });
      } else {
        mainDataRow.push({
          BuyBackFeeId: item.id || "NA",
          CustomerName: item.customerName || "NA",
          CustomerLocationName: item.customerLocationName || "NA",
          City: item.city || "NA",
          State: item.state || "NA",
          Vendor: `${vendor.vendorLocationName}${vendor.city ? `- ${vendor.city}` : ''}${vendor.state ? `- ${vendor.state}` : ''}` || "NA",
          PalletType: "NA",
          VendorFee: "NA",
          CustomerFee: "NA",
          StartDate: "NA",
          EndDate: "NA",
          Comment: "NA"
        });
      }
    });
    return mainDataRow;
  });

  return tempCsvData;
}


let csvFinalData = [];
const handlePtPlusBuyBackCsvExportClick = async (filter, tableSearch, setIsDownloadingPtPlusBuyBackFeeCSV, setPtPlusCsvBuyBackReportData, ptPlusBuyBackrCsvCurrentPage, setPtPlusBuyBackCsvCurrentPage, setPtPlusBuyBackCsvTotalPages, dispatch) => {

  let data = {
    size: 100,
    number: ptPlusBuyBackrCsvCurrentPage,
    sort: "ASC",
    searchCriteria: {
      customerIds: filter?.customerIds?.length > 0 ? filter?.customerIds : null,
      locationIds: filter?.locationIds?.length > 0 ? filter?.locationIds : null,
      vendorIds: filter?.vendorIds?.length > 0 ? filter?.vendorIds : null,
      searchBy: tableSearch || null,
      active: filter.active
    }
  }
  let response = await dispatch(ptPlusBuyBackListing(data));
  if (response && response?.success && response?.data && response?.data?.buyBackList) {
    let resultApiData = response?.data?.buyBackList
    if (resultApiData === null) resultApiData = []
    const totalPages = response?.data?.totalPages ?? 1;
    setPtPlusBuyBackCsvTotalPages(totalPages)
    csvFinalData.push(...resultApiData)

    if (totalPages > ptPlusBuyBackrCsvCurrentPage + 1) {
      const nextPage = ptPlusBuyBackrCsvCurrentPage + 1;
      setPtPlusBuyBackCsvCurrentPage(nextPage)

      handlePtPlusBuyBackCsvExportClick(filter, tableSearch, setIsDownloadingPtPlusBuyBackFeeCSV, setPtPlusCsvBuyBackReportData, nextPage, setPtPlusBuyBackCsvCurrentPage, setPtPlusBuyBackCsvTotalPages, dispatch)
      return;
    }

    const preparedCsvData = prepareCsvData(csvFinalData)
    setIsDownloadingPtPlusBuyBackFeeCSV(false)
    setPtPlusCsvBuyBackReportData(preparedCsvData);

    const ptPlusBuyBackCsvExportRef = document.querySelector("#ptPlusBuyBackCsvExportRef")
    if (ptPlusBuyBackCsvExportRef) {
      setTimeout(() => {
        ptPlusBuyBackCsvExportRef.click();
      }, 500);
    }
  } else {
    setIsDownloadingPtPlusBuyBackFeeCSV(false)
  }
}

export const ExportPtPlusBuyBackReport = (filter, tableSearch, setIsDownloadingPtPlusBuyBackFeeCSV, setPtPlusCsvBuyBackReportData, ptPlusBuyBackrCsvCurrentPage, setPtPlusBuyBackCsvCurrentPage, setPtPlusBuyBackCsvTotalPages, dispatch) => {
  setIsDownloadingPtPlusBuyBackFeeCSV(true)
  csvFinalData = [];
  handlePtPlusBuyBackCsvExportClick(filter, tableSearch, setIsDownloadingPtPlusBuyBackFeeCSV, setPtPlusCsvBuyBackReportData, ptPlusBuyBackrCsvCurrentPage, setPtPlusBuyBackCsvCurrentPage, setPtPlusBuyBackCsvTotalPages, dispatch)
}

export const ptPlusBuyBackCSVHeaderArray = [
  { id: 'BuyBackFeeId', displayName: 'Buyback Fee Id' },
  { id: 'CustomerName', displayName: 'Customer Name' },
  { id: 'CustomerLocationName', displayName: 'Customer Location' },
  { id: 'City', displayName: 'City' },
  { id: 'State', displayName: 'State' },
  { id: 'Vendor', displayName: 'Buyback Vendor' },
  { id: 'PalletType', displayName: 'Pallet Type' },
  { id: 'VendorFee', displayName: 'Vendor Price' },
  { id: 'CustomerFee', displayName: 'Customer Price' },
  { id: 'StartDate', displayName: 'Start Date' },
  { id: 'EndDate', displayName: 'End Date' },
  { id: 'Comment', displayName: 'Comment' },
];